import { useState } from 'react';

import { useLivePetContentQuery } from '@/entities/live-pet-content';

import { LivePetDrawer } from './LivePetDrawer';
import { SpecialtyLineItem } from './SpecialtyLineItem';

export const LivePetLineItem = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const { livePetData } = useLivePetContentQuery();

    const { header = '', body = null } = livePetData ?? {};

    const handleToggleDrawer = () => setIsDrawerOpen(prev => !prev);

    return (
        <>
            <SpecialtyLineItem
                role="button"
                icon="heartbeat"
                ariaLabel="Live pet information"
                onClickAction={handleToggleDrawer}
                text="Live pet - Available in-store only"
                shouldShowDetailsButton={Boolean(header) && Boolean(body)}
            />
            <LivePetDrawer open={isDrawerOpen} header={header} body={body} onCloseAction={handleToggleDrawer} />
        </>
    );
};
